export function getTitle (state) {
  return state.title
}
export function getText (state) {
  return state.text
}
export function getInformation (state) {
  return state.information
}
export function getCreate (state) {
  return state.create
}
export function getCreateText (state) {
  return state.createText
}
export function getBreadcrumb (state) {
  return state.breadcrumb
}
export function getSearchField (state) {
  return state.searchField
}
